export default __webpack_public_path__ + "static/media/source_google.28a47a87.svg";